import React, { ReactNode } from 'react'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'

interface Props {
  readonly children: ReactNode
  readonly className?: string
  readonly height?: number
  readonly color?: string
}

const getBarCss = (height: number, color: string) => css`
  height: ${height}px;
  min-height: ${height}px;
  background-color: ${color};
  display: table-cell;
  vertical-align: middle;
  width: 100vw;
`

export function HeaderBar({
  children,
  className,
  height = 30,
  color = theme.color.blue90
}: Props) {
  return (
    <div className={cx(getBarCss(height, color), className)}>{children}</div>
  )
}
